<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.expresses'), $t('text.list')]">
        <el-button type="success" size="mini" @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>

    <div class="wrapper table-area">
      <vxe-table
        :data="expressTenants"
        :loading="loading"
        id="courierTenantTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="name" :title="$t('text.name')" />
        <vxe-table-column
          field="expressId"
          :title="$t('express.printFaceSheet')"
        >
          <template v-slot="{ row }">
            <span v-if="row.expressId != null">{{ $t("boolean.true") }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="payType" :title="$t('express.payType')">
          <template v-slot="{ row }">
            <span v-if="row.express != null && row.payType != null">{{
              $t("expressPayTypes." + row.payType)
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="cainiaoDelivery"
          :title="$t('express.cainiaoDelivery')"
        >
          <template v-slot="{ row }">
            <span
              v-if="
                row.cainiaoDelivery != null &&
                row.expressId != null &&
                row.express.tbExpressCode != null
              "
              >{{ $t("boolean." + row.cainiaoDelivery) }}</span
            >
          </template>
        </vxe-table-column>
        <vxe-table-column field="action" :title="$t('text.action')" width="100">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="edit(row)">{{
              $t("text.edit")
            }}</el-button>
            <el-button type="text" size="mini" @click="deleteRow(row)">{{
              $t("text.delete")
            }}</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>

    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="40%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              :prop="'name'"
              :rules="[
                { required: true, validator: validateName, trigger: 'blur' },
              ]"
              :label="$t('text.name')"
            >
              <el-autocomplete
                size="small"
                v-model.trim="addObj.name"
                :fetch-suggestions="querySearchName"
                style="width: 100%"
                @select="handleSelectName"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="addObj.expressId != null && addObj.name != null"
              :prop="'payType'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.select', [$t('express.payType')]),
                  trigger: 'blur',
                },
              ]"
              :label="$t('express.payType')"
            >
              <el-radio-group
                size="small"
                v-if="addObj._code == 'SF'"
                v-model="addObj.payType"
              >
                <el-radio
                  v-for="payType of payTypes"
                  :key="payType"
                  :label="payType"
                  >{{ $t("expressPayTypes." + payType) }}</el-radio
                >
              </el-radio-group>
              <el-radio-group
                size="small"
                v-if="addObj._code != 'SF'"
                v-model="addObj.payType"
              >
                <el-radio
                  v-for="payType of payTypes2"
                  :key="payType"
                  :label="payType"
                  >{{ $t("expressPayTypes." + payType) }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="addObj.expressId == null && addObj.name != null"
            >
              <div class="orange">没有对接</div>
            </el-form-item>
          </el-col>
          <span v-if="addObj.expressId != null && addObj.name != null">
            <el-col v-if="needPlay('customerName', addObj._code)" :span="12">
              <el-form-item
                :label="$t('express.customerName')"
                prop="customerName"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('express.customerName')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="addObj.customerName" />
              </el-form-item>
            </el-col>
            <el-col v-if="needPlay('customerPwd', addObj._code)" :span="12">
              <el-form-item
                :label="$t('express.customerPwd')"
                prop="customerPwd"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('express.customerPwd')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="addObj.customerPwd" />
              </el-form-item>
            </el-col>
            <el-col v-if="needPlay('monthCode', addObj._code)" :span="12">
              <el-form-item
                :label="$t('express.monthCode')"
                prop="monthCode"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('express.monthCode')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="addObj.monthCode" />
              </el-form-item>
            </el-col>
            <el-col v-if="needPlay('sendSite', addObj._code)" :span="12">
              <el-form-item
                :label="$t('express.sendSite')"
                prop="sendSite"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('express.sendSite')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="addObj.sendSite" />
              </el-form-item>
            </el-col>
            <el-col v-if="needPlay('sendStaff', addObj._code)" :span="12">
              <el-form-item
                :label="$t('express.sendStaff')"
                prop="sendStaff"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('express.sendStaff')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="addObj.sendStaff" />
              </el-form-item>
            </el-col>
          </span>
          <el-col v-if="addObj._tbExpressCode != null" :span="12">
            <el-form-item
              :label="$t('express.cainiaoDelivery')"
              prop="cainiaoDelivery"
            >
              <el-checkbox size="small" v-model="addObj.cainiaoDelivery" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="saveDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="40%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              :prop="'name'"
              :rules="[
                {
                  required: true,
                  validator: validateNameEdit,
                  trigger: 'blur',
                },
              ]"
              :label="$t('text.name')"
            >
              <el-input
                size="small"
                v-model.trim="editObj.name"
                :placeholder="$t('text.name')"
                :disabled="editObj._expressId != null"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="editObj._expressId != null && editObj.name != null"
              :label="$t('express.payType')"
            >
              <el-radio-group
                size="small"
                v-if="editObj._code == 'SF'"
                v-model="editObj.payType"
              >
                <el-radio
                  v-for="payType of payTypes"
                  :key="payType"
                  :label="payType"
                  >{{ $t("expressPayTypes." + payType) }}</el-radio
                >
              </el-radio-group>
              <el-radio-group
                size="small"
                v-if="editObj._code != 'SF'"
                v-model="editObj.payType"
              >
                <el-radio
                  v-for="payType of payTypes2"
                  :key="payType"
                  :label="payType"
                  >{{ $t("expressPayTypes." + payType) }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="editObj._expressId == null && editObj.name != null"
            >
              <div class="orange">没有对接</div>
            </el-form-item>
          </el-col>
          <span v-if="editObj._expressId != null && editObj.name != null">
            <el-col v-if="needPlay('customerName', editObj._code)" :span="12">
              <el-form-item
                :label="$t('express.customerName')"
                prop="customerName"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('express.customerName')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="editObj.customerName" />
              </el-form-item>
            </el-col>
            <el-col v-if="needPlay('customerPwd', editObj._code)" :span="12">
              <el-form-item
                :label="$t('express.customerPwd')"
                prop="customerPwd"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('express.customerPwd')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="editObj.customerPwd" />
              </el-form-item>
            </el-col>
            <el-col v-if="needPlay('monthCode', editObj._code)" :span="12">
              <el-form-item
                :label="$t('express.monthCode')"
                prop="monthCode"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('express.monthCode')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="editObj.monthCode" />
              </el-form-item>
            </el-col>
            <el-col v-if="needPlay('sendSite', editObj._code)" :span="12">
              <el-form-item
                :label="$t('express.sendSite')"
                prop="sendSite"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('express.sendSite')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="editObj.sendSite" />
              </el-form-item>
            </el-col>
            <el-col v-if="needPlay('sendStaff', editObj._code)" :span="12">
              <el-form-item
                :label="$t('express.sendStaff')"
                prop="sendStaff"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('express.sendStaff')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="editObj.sendStaff" />
              </el-form-item>
            </el-col>
          </span>
          <el-col v-if="editObj._tbExpressCode != null" :span="12">
            <el-form-item
              :label="$t('express.cainiaoDelivery')"
              prop="cainiaoDelivery"
            >
              <el-checkbox size="small" v-model="editObj.cainiaoDelivery" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Express from "@/api/express.js";

export default {
  mixins: [page],
  components: {},
  data() {
    var validateName = (rule, value, callback) => {
      if (value == null || value === "") {
        callback(new Error(this.$t("rules.required", [this.$t("text.name")])));
        return;
      }
      const names = this.expressTenants.map((s) => s.name);
      if (names.includes(value.toUpperCase())) {
        callback(new Error(this.$t("rules.exist", [this.$t("text.name")])));
        return;
      } else {
        callback();
      }
    };
    var validateNameEdit = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(new Error(this.$t("rules.required", [this.$t("text.name")])));
        return;
      }
      if (
        self.expressTenants.filter((s) => s.name === value.toUpperCase())
          .length > 1
      ) {
        callback(new Error(this.$t("rules.exist", [this.$t("text.name")])));
        return;
      }
      if (self.editObj._expressId != null) {
        callback();
      } else {
        Express.findByName({ name: value }).then(function (res) {
          if (res.data !== "") {
            callback(new Error(self.$t("prompt.hasBeenDockedPleaseAdd")));
            return;
          } else {
            callback();
          }
        });
      }
    };
    return {
      expressTenants: [],
      // 新增
      payTypes: [1, 2, 3, 4],
      payTypes2: [1, 2, 3],
      validateName: validateName,
      addDF: false,
      addObj: {
        name: null,
        expressId: null,
        payType: null,
        isNotice: null, // 0 1代表和快递对接后是否通知上门取货。 -1即不是对接的
        templateSizes: null,
        customerName: null,
        customerPwd: null,
        monthCode: null,
        sendSite: null,
        sendStaff: null,
        _code: null,
        cainiaoDelivery: false,
        cainiaoTemplateUrl: null,
        _tbExpressCode: null,
      },
      saveDoing: false,
      // 编辑
      validateNameEdit: validateNameEdit,
      editDF: false,
      row: null,
      editObj: {
        name: null,
        payType: null,
        isNotice: null,
        templateSizes: null,
        customerName: null,
        customerPwd: null,
        monthCode: null,
        sendSite: null,
        sendStaff: null,
        _expressId: null,
        _code: null,
        _tbExpressCode: null,
        cainiaoDelivery: false,
        cainiaoTemplateUrl: null,
      },
      editDoing: false,
    };
  },
  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(self.$t("prompt.confirmDelete"))) {
        Express.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row) {
      this.row = row;
      this.editObj.name = row.name;
      this.editObj.payType = row.payType;
      this.editObj.isNotice = row.isNotice;
      this.editObj._expressId = row.expressId;
      if (this.editObj._expressId != null) {
        this.editObj._code = row.express.code;
        this.editObj._tbExpressCode = row.express.tbExpressCode;
      }
      this.editObj.customerName = row.customerName;
      this.editObj.customerPwd = row.customerPwd;
      this.editObj.monthCode = row.monthCode;
      this.editObj.sendSite = row.sendSite;
      this.editObj.sendStaff = row.sendStaff;
      this.editObj.cainiaoDelivery = row.cainiaoDelivery;
      this.editDoing = false;
      this.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          Express.update(self.row.id, self.editObj).then(function (res) {
            if (res.status === 200) {
              self.editDoing = false;
              self.editDF = false;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增

    needPlay(area, code) {
      if (area === "customerName") {
        if (
          [
            "EMS",
            "ZJS",
            "ZTO",
            "STO",
            "DBL",
            "JD",
            "XFEX",
            "HHTT",
            "GTO",
            "SURE",
            "KYSY",
            "YD",
            "HTKY",
            "YTO",
            "YCWL",
            "UC",
            "ANE",
            "PJ",
            "CND",
          ].includes(code)
        ) {
          return true;
        }
        return false;
      }
      if (area === "customerPwd") {
        if (
          [
            "EMS",
            "ZJS",
            "ZTO",
            "STO",
            "XFEX",
            "HHTT",
            "GTO",
            "YD",
            "HTKY",
            "UC",
            "PJ",
            "CND",
          ].includes(code)
        ) {
          return true;
        }
        return false;
      }
      if (area === "monthCode") {
        if (["YTO", "SF"].includes(code)) {
          return true;
        }
        return false;
      }
      if (area === "sendSite") {
        if (
          ["STO", "XFEX", "HHTT", "GTO", "SURE", "YCWL", "ANE", "CND"].includes(
            code
          )
        ) {
          return true;
        }
        return false;
      }
      if (area === "sendStaff") {
        if (["SURE"].includes(code)) {
          return true;
        }
        return false;
      }
      return false;
    },

    add() {
      this.addObj.name = null;
      this.addObj.expressId = null;
      this.addObj.payType = null;
      this.addObj.isNotice = -1; // 0 1代表和快递对接后是否通知上门取货。 -1即不是对接的
      this.addObj.payType = null;
      this.addObj.customerName = null;
      this.addObj.customerPwd = null;
      this.addObj.monthCode = null;
      this.addObj.sendSite = null;
      this.addObj.sendStaff = null;
      this.addObj.cainiaoDelivery = false;
      this.saveDoing = false;
      this.addDF = true;
    },
    querySearchName(queryString, cb) {
      const self = this;
      self.addObj.expressId = null;
      self.addObj.isNotice = null;
      self.addObj.templateSizes = null;
      self.addObj._code = null;
      Express.all().then(function (res) {
        const expresses = res.data;
        if (expresses.length !== 0) {
          for (const e of expresses) {
            Vue.set(e, "value", e.name);
          }
          cb(expresses);
        }
      });
    },

    handleSelectName(item) {
      const self = this;
      self.addObj.expressId = item.id;
      self.addObj.isNotice = 0;
      self.addObj.templateSizes = null;
      self.addObj._code = item.code;
      self.addObj._tbExpressCode = item.tbExpressCode;
    },

    addSubmit() {
      const self = this;
      self.$refs.addObjForm.validate((valid) => {
        if (valid) {
          self.saveDoing = true;
          Express.create(self.addObj).then(function (res) {
            self.saveDoing = false;
            self.addDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    loadData() {
      const self = this;
      self.loadingStart();
      Express.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.expressTenants = res.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
  },
};
</script>
<style scoped>
</style>